import { getRoute, reactLazyImport } from "helpers";
import FrontendLayout from "pages/frontend/FrontendLayout";
import { SURVEY_MODULE_FOLDER, SURVEY_MODULE_PREFIX } from "../pvs_activities/constants";

const SurveyTemplatesIndex = reactLazyImport(
    "/pages/forms/index",
    "SurveyTemplatesIndex",
    SURVEY_MODULE_FOLDER
);
const SurveyData = reactLazyImport(
    "/components/SurveyView",
    "SurveyView",
    SURVEY_MODULE_FOLDER
);

const SurveyWorkspace = reactLazyImport(
    "/components/SurveyWorkspace",
    "SurveyWorkspace",
    SURVEY_MODULE_FOLDER
);

const router = {
    3: [
        getRoute({
            path: `/portal/survey-cc`,
            element: (
                <FrontendLayout children={<SurveyWorkspace />} secure={true} />
            ),
        }),
        getRoute({
            path: `/portal/survey-data/:id`,
            element: (
                <FrontendLayout children={<SurveyData />} secure={true} />
            ),
        }),
        getRoute({
            path: `/portal/${SURVEY_MODULE_PREFIX}/survey-library`,
            element: (
                <FrontendLayout children={<SurveyTemplatesIndex />} secure={true} />
            ),
        })
    ]
};

export default router;